<template>
  <div>
    <!-- =================================Loading ======================================================= -->
    <div
      style="margin: 0"
      class="loading-waiting"
      v-bind:style="{ display: finish == true ? 'none' : '' }"
    >
      <div>
        <div class="load-4">
          <div class="ring-1"></div>
        </div>
        <div class="load-wrapp">
          <div class="load-6">
            <div class="letter-holder">
              <div class="l-1 letter">l</div>
              <div class="l-2 letter">o</div>
              <div class="l-3 letter">a</div>
              <div class="l-4 letter">d</div>
              <div class="l-5 letter">i</div>
              <div class="l-6 letter">n</div>
              <div class="l-7 letter">g</div>
              <div class="l-8 letter">.</div>
              <div class="l-9 letter">.</div>
              <div class="l-10 letter">.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- =================================Loading ======================================================= -->
    <v-container fluid>
      <div>
        <v-row>
          <v-col
            cols="12"
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;"
          >
            <h3 style="font-weight: 700" class="font_style">Calendar</h3>
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12">
            <v-card>
              <v-card-title>
                <div class="d-flex" style=" align-items: center; width: 180px;">
                  <label style="color:black;width:60px">Year :</label>
                  <div class="select-dropdown">
                    <select
                      style="width: 100px "
                      v-model="currentYear"
                      class="form-control"
                      @change="getdatepicker(currentYear)"
                    >
                      <option
                        v-for="year in types_year"
                        :value="year"
                        :key="year"
                      >
                        {{ year }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="d-flex" style="align-items: center; width: 130px;">
                  <v-btn
                    rounded
                    color="#AA4465"
                    style="color:#fff"
                    depressed
                    v-b-modal.modal_range
                    :disabled="role_status !== 'super_admin' && role_status !== 'master_admin'"
                  >
                  Add Event
                  </v-btn>
                  <b-modal 
                    ref="modal_range_date" 
                    id="modal_range" 
                    centered 
                    hide-footer
                    no-close-on-backdrop
                  >
                  <template #modal-header >
                    <h4 id="add-event-header" style="text-align: center; font-family: 'Bai_Jamjuree' !important;">Add Event</h4>
                  <b-icon style="width: 30px; height: 30px;  font-weight: bold;" icon="x-circle" variant="dark" @click="closeModal()"></b-icon>
                  </template>
                    <template #default>
                      <v-row>
                        <v-col cols="2" class="Date-add-event" style="text-align: center; font-family: 'Bai_Jamjuree' !important;">
                          <h5>Date</h5>
                        </v-col>
                        <v-col cols="8" style="font-family: 'Bai_Jamjuree' !important;">
                          <cv-date-picker
                            placeholder="dd/mm/yyyy"
                            light
                            kind="range"
                            :date-end-label="dateRangeLabel"
                            :cal-options="calOptions"
                            @change="actionChange(holiday)"
                            v-model="holiday"
                          >
                          </cv-date-picker>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="2" class="Detail-add-event" style="text-align: center; font-family: 'Bai_Jamjuree' !important;">
                          <h5>Detail</h5>
                        </v-col>
                        <v-col cols="8" style="text-align: center; font-family: 'Bai_Jamjuree' !important;">
                          <b-form-textarea
                            id="textarea-state"
                            v-model="detail"
                            placeholder="กรุณากรอกข้อความ"
                            rows="4"
                            :state="detail.length >= 1"
                            style="width: 360px;"
                          ></b-form-textarea>
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <div class="d-flex justify-content-center">
                        <div style="width: 10px"></div>
                          <b-button
                            pill
                            data-dismiss="modal"
                            class="mt-3"
                            variant="success"
                            style="background-color: #599E52; border-color: #599E52; color: #fff; text-align: center; font-family: 'Bai_Jamjuree' !important;"
                            @click="getaddholiday()"
                            :disabled="detail == ''|| holiday.startDate == null || holiday.endDate == null"
                            >SAVE</b-button
                          >
                      </div>
                    </template>
                  </b-modal>
                </div>
                <div>
                  <v-dialog
                    v-model="dialog"
                    persistent
                    max-width="500"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :disabled="checkDelete == false || (role_status !== 'super_admin' && role_status !== 'master_admin') "
                        depressed
                        rounded
                        color="#EC5F59"
                        style="color:#fff"
                        v-bind="attrs"
                        v-on="on"
                        @click="deleteEvent()"
                      >
                        Delete
                      </v-btn>
                    </template>
                    <v-card>
                      <div class="text-center" >
                        <v-card-title class="text-h5" style="justify-content: center; font-family: 'Bai_Jamjuree' !important;">
                          <div class="text-h5" style="justify-content: center; font-family: 'Bai_Jamjuree' !important;">
                            คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้ ?
                          </div>
                        </v-card-title>
                          <div style="text-align: center; font-family: 'Bai_Jamjuree' !important;" >
                            <p><strong>Detail :</strong> {{ eventDetail }}</p>
                            <p><strong>Holiday :</strong> {{ eventHoliday }}</p>
                          </div>
                        <v-divider></v-divider>
                          <v-btn
                            depressed
                            rounded
                            class="ma-1"
                            style="background-color: #aaaaaa;  color: #fff;"
                            @click="closeDialog()"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            depressed
                            rounded
                            class="ma-1"
                            color="#EC5F59"
                            style="color:#fff"
                            @click="getdelholiday()"
                          >
                            Delete
                          </v-btn>
                      </div>
                    </v-card>
                  </v-dialog>
                </div>
              </v-card-title>
              <v-divider></v-divider>
              <div>
                <v-card>
                  <vc-calendar
                    color="pink"
                    :from-date="new Date(this.currentYear, 0, 1)"
                    :attributes="attributesData"
                    :locale="modifiedLocale"
                    :columns="$screens({ default: 1, xl: 3 })"
                    :rows="$screens({ default: 1, xl: 4 })"
                    :is-expanded="$screens({ default: true, xl: false })"
                    :disabled-dates="{ weekdays: [1, 7] }"
                    :disable-page-swipe="true"
                    data-popper-placement="none" 
                    @dayclick="onDayClick"
                  >
                    <template #day-popover="{ attributes}">
                      <div v-for="{ key, customData } in attributes" :key="key">
                        {{ customData.detail }}
                      </div>
                    </template>
                  </vc-calendar>
                </v-card>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import { BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
Vue.use(BootstrapVueIcons)
import moment from "moment";
import Vue from "vue";
import TextareaAutosize from "vue-textarea-autosize";
Vue.use(TextareaAutosize);
import "carbon-components/css/carbon-components.min.css";
import "carbon-components/css/carbon-components.css";
import Swal from "sweetalert2";

let x;
export default {
  data() {
    return {
      detail: '',
      dialog: false,
      types_year: [],
      currentYear: new Date().getFullYear(),
      date: new Date(),
      dates:[],
      attributesData: [],
      finish: false,
      rules: {
        date: [(val) => (val || "").length > 0 || "กรุณาเลือกวันที่"],
        detail: [(val) => (val || "").length > 0 || "กรุณากรอกข้อความ "],
      },
      export_date: [null, null],
      dateRangeLabel: "End date",
      calOptions: {
        dateFormat: "d/m/Y",
      },
      holiday: {
        startDate: null,
        endDate: null,
      },
      menu: false,
      eventDetail: "", // ตัวแปรสำหรับเก็บรายละเอียดของเหตุการณ์ที่คลิก
      eventHoliday: "", // ตัวแปรสำหรับเก็บวันหยุดของเหตุการณ์ที่คลิก
      checkDelete: false,
      role_status: "",
      biz_id : "",
    };
  },
  created() {
    this.role_status = localStorage.getItem("role");
    this.biz_id = localStorage.getItem("biz_id");
  },
  mounted() {
    this.prepareYearOptions();
    this.getdatepicker(this.currentYear);
    this.finish = true;
    this.attributesData;
  },
  watch: {},
  computed: {
    modifiedLocale() {
      return {
        id: "EN",
        firstDayOfWeek: 1,
        masks: { weekdays: "WWW",title: "MMMM" },
      };
    },
  },
  methods: {
    closeDialog(){
      this.dialog = false;
      this.checkDelete = false
    },
    closeModal(){
      this.$refs["modal_range_date"].hide();
      this.holiday.startDate = null;
      this.holiday.endDate = null;
      this.holiday[0] = null;
      this.holiday[1] = null;
      this.detail = '';
    },
    actionChange(date){
      this.holiday[0] = date.startDate
      .split("/")
      .reverse()
      .join("-");
      this.holiday[1] = date.endDate
      .split("/")
      .reverse()
      .join("-");
    },
    prepareYearOptions() {
      const monthYear = new Date().getFullYear();
      for (let i = monthYear - 3; i <= monthYear + 3; i++) {
        this.types_year.push(i);
      }
    },
    convertDateFormat(dateString) {
      let parts = dateString.split('/');
      let formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
      return formattedDate;
    },
    deleteEvent(){
      this.eventDetail = x.detail;
      this.eventHoliday = moment(x.holiday).format('DD/MM/YYYY');
    },

    onDayClick(day) {
      // console.log(day);
      x = ''
      const eventsForClickedDay = this.arrayEvents.filter(data => {
      const eventDate = new Date(data.holiday);
      return eventDate.getFullYear() === day.date.getFullYear() &&
        eventDate.getMonth() === day.date.getMonth() &&
        eventDate.getDate() === day.date.getDate();
      });
      eventsForClickedDay.forEach(data => {
       x = data
      });
      if(x == ''){
        this.checkDelete = false
      }else{
        this.checkDelete = true
      }
    },
    getdelholiday(){
      this.finish = false;
      let headers = {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Authorization:
            "Bearer " +
            localStorage.getItem("acces_token") +
            "," +
            localStorage.getItem("secret"),
        },
        responseType: "blob",
      };
      let data = {
         holiday: this.convertDateFormat(this.eventHoliday),
      };
      // console.log("data",data)
      this.axios
        .post(process.env.VUE_APP_API + "/calendar/delholiday?biz_id="+this.biz_id,data, headers)
        .then((response) => {
          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "ลบข้อมูลเรียบร้อยแล้ว",
              showConfirmButton: false,
              timer: 3000,
            })
            this.dialog = false;
            this.closeModal();
            setTimeout(() => {
              this.finish = false;
              this.getdatepicker(this.currentYear);
            }, 5000);
            this.checkDelete = false
          }
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.finish = true;
            this.$router.push("/login");
          }
        });
    },
    getaddholiday() {
      this.finish = false;
      let headers = {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Authorization:
            "Bearer " +
            localStorage.getItem("acces_token") +
            "," +
            localStorage.getItem("secret"),
        },
        responseType: "blob",
      };
      let formattedStartDate = this.convertDateFormat(this.holiday.startDate);
      let formattedEndDate = this.convertDateFormat(this.holiday.endDate);
      let data = {
         // holiday: this.holiday,
        detail: this.detail,
        start_date: formattedStartDate,
        end_date: formattedEndDate,
      };
      // console.log("data",data)
      this.axios
        .post(process.env.VUE_APP_API + "/calendar/addholiday?biz_id="+this.biz_id,data, headers)
        .then((response) => {
          Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 3000,
          })
          if (response.status === 200) {
            this.dialog = false;
            this.closeModal();
            setTimeout(() => {
              this.finish = false;
              this.getdatepicker(this.currentYear);
            }, 5000);
          }
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.finish = true;
            this.$router.push("/login");
          }
        });
    },
    async getdatepicker(currentYear) {
      try {
        this.finish = false;
        let headers = {
          headers: {
            Authorization:
              "Bearer " +
              localStorage.getItem("acces_token") +
              "," +
              localStorage.getItem("secret"),
          },
        };
        const response = await this.axios.get(
          process.env.VUE_APP_API + `/calendar/getholiday?year=${currentYear}&biz_id=`+this.biz_id,
          headers
        );

        if (response && response.status === 200) {
          this.arrayEvents = response.data.data;
          this.finish = true;
          this.attributesData = this.arrayEvents.map((data) => {
            return {
              dot: { color: "#6E7781" },
              dates: new Date(data.holiday),
              popover: {
                label: data.detail,
                visibility: "click",
              },
              customData: data,
            };
          });
          this.attributesData.push({
            highlight: true,
            dates: new Date(),
          });
          this.finish = true;
        } else {
          this.finish = true;
        }
      } catch (error) {
        this.finish = true;
        if (error.response && error.response.status == 401) {
          this.$router.push("/login");
        }
      }
    },
  },
};
</script>
<style >
h4 {
  font-weight: bold;
}
.swal2-title {
  position: relative;
  font-family: "Bai_Jamjuree" !important;
  max-width: 100%;
  margin: 0 0 0.4em;
  padding: 0;
  color: #595959;
  font-size: 1.875em;
  font-weight: 600;
  text-align: center;
  text-transform: none;
  word-wrap: break-word;
}
#modal_range .modal-header {
    background-color: rgba(251, 177, 189, 0.78) !important;
  }
#modal_range .modal-content {
    width: 500px !important;
    margin: auto !important;
}
.Date-add-event{
  display: flex !important;
  align-items: center !important;
}
.Detail-add-event{
  display: flex !important;
  align-items: center !important;
}

@font-face {
  font-family: "Bai_Jamjuree";
  src: url("~@/assets/Bai_Jamjuree/BaiJamjuree-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Bai_Jamjuree";
  src: url("~@/assets/Bai_Jamjuree/BaiJamjuree-Medium.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}
.container {
  font-family: "Bai_Jamjuree" !important;
  background-color: rgb(250, 250, 250) !important;
}
.v-card-title {
  font-family: "Bai_Jamjuree" !important;
}

@media (min-width: 960px) {
  .container {
    max-width: 100% !important;
    background-color: rgb(250, 250, 250) !important;
  }
}
.select-dropdown,
.select-dropdown * {
  margin: 0 !important;
  padding: 0 !important;
  position: relative !important;
  box-sizing: border-box !important;
}
.select-dropdown {
  position: relative !important;
  border-radius: 4px !important;
  border: 1px solid #000000 !important;
}
.select-dropdown select {
  font-size: 1rem !important;
  font-weight: normal !important;
  max-width: 100% !important;
  padding: 8px 24px 8px 10px !important;
  border: none !important;
  background-color: transparent !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}
.select-dropdown select:active,
.select-dropdown select:focus {
  outline: none !important;
  box-shadow: none!important;
}
.select-dropdown:after {
  content: "" !important;
  position: absolute !important;
  top: 50% !important;
  right: 8px !important;
  width: 0 !important;
  height: 0 !important;
  margin-top: -2px !important;
  border-top: 5px solid #aaa !important;
  border-right: 5px solid transparent !important;
  border-left: 5px solid transparent !important;
}
.date_input {
  display: flex !important;
  align-items: baseline !important;
  justify-content: flex-start !important;
}
.v-card__actions {
  align-items: center !important;
  display: flex !important;
  padding: 8px !important;
  justify-content: space-evenly !important;
}
.vc-day-popover-container {
  color: #000 !important;
  background-color: #eeeeee !important;
  border: 1px solid;
  border-color: #eeeeee !important;
  border-radius: var(--rounded) !important;
  font-size: var(--text-xs) !important;
  font-weight: var(--font-medium) !important;
  padding: 4px 8px !important;
  box-shadow: var(--shadow) !important;
  font-family: "Bai_Jamjuree" !important;
}

.vc-title[data-v-74ad501d] {
  font-size: 19px !important;
  color: #000 !important;
  font-weight: var(--font-semibold)!important;
  line-height: 28px !important;
  cursor: pointer !important;
  -webkit-user-select: none !important;
  user-select: none !important;
  white-space: nowrap !important;
  font-family: "Bai_Jamjuree" !important;
}

.vc-dot {
  background-color: #6e7781 !important;
}

.vc-weekday[data-v-74ad501d] {
  text-align: center !important;
  color: #6e7781 !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 16px !important;
  padding-top: 4px !important;
  padding-bottom: 8px !important;
  cursor: default !important;
  -webkit-user-select: none !important;
  user-select: none !important;
  font-family: "Bai_Jamjuree" !important;
  text-transform: uppercase !important;
}

.vc-day-content[data-v-4420d078] {
  display: flex !important;
  justify-content: center !important;
  align-items: center!important;
  font-size: var(--text-sm) !important;
  font-weight: var(--font-medium) !important;
  width: 28px !important;
  height: 28px !important;
  line-height: 28px !important;
  border-radius: var(--rounded-full) !important;
  -webkit-user-select: none !important;
  user-select: none !important;
  cursor: pointer !important;
  font-family: "Bai_Jamjuree" !important;
}
.vc-dot[data-v-4420d078] {
  width: 7px !important;
  height: 7px !important;
  border-radius: 50% !important;
  transition: all var(--day-content-transition-time) !important;
}
.vc-container {
  --font-normal: 400 !important;
  --font-medium: 500 !important;
  --font-semibold: 600 !important;
  --font-bold: 600 !important;
  --text-xs: 12px !important;
  --text-sm: 17px !important;
  --text-base: 16px !important;
  --text-lg: 19px !important;
  --leading-snug: 1.375 !important;
  --rounded: 0.25rem !important;
  --rounded-lg: 0.5rem !important;
  --rounded-full: 9999px !important;
  --shadow: 0 0px 0px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06) !important;
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
  --shadow-inner: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06) !important;
  --slide-translate: 22px !important;
  --slide-duration: 0.15s !important;
  --slide-timing: ease !important;
  --day-content-transition-time: 0.13s ease-in !important;
  --weeknumber-offset: -34px !important;
  position: relative !important;
  display: contents !important;
  width: max-content !important;
  height: max-content !important;
  font-family: "Bai_Jamjuree" !important;
  color: var(--gray-900) !important;
  background-color: var(--white) !important;
  border: 1px solid !important;
  border-color: var(--gray-400) !important;
  border-radius: var(--rounded-lg) !important;
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
  -webkit-tap-highlight-color: transparent !important;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    inset 0px 0px 0px 0px rgba(0, 0, 0, 0.14),
    0px 0px 0px 0px rgba(0, 0, 0, 0.12) !important;
}
.vc-weekday[data-v-74ad501d]:nth-child(7),
.vc-weekday[data-v-74ad501d]:nth-child(1) {
  color: #ff3226 !important;
}
.vc-svg-icon {
  display: none !important;
}
.vc-day-content.is-disabled {
  color: #ff3226 !important;
}
.day-popover-weekday {
  text-transform: uppercase !important;
}

.vc-popover-content-wrapper {
  display: block !important;
}

.vc-header .vc-title {
  cursor: context-menu !important;
}

.vc-header .vc-title:hover {
  cursor: context-menu !important;
  opacity: 1 !important;
}
.text-field-detail .v-input__slot {
  width: 380px !important;
  height: 100px !important;
  border-radius: 4px !important;
  font-size: 16px !important;
}
.vc-popover-content-wrapper .is-interactive {
  display: block !important;
}
.vc-popover-content-wrapper[data-v-03f17c2c] {
  display: block !important;
}
.data-popper-placement {
   display: block !important;
}
/* // ======================================loading..==============================================// */
.loading-waiting {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: #ecf5ff62;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 101;
}

.load-4 .ring-1 {
  animation: loadingD 1.5s 0.3s cubic-bezier(0.17, 0.37, 0.43, 0.67) infinite;
}

@keyframes loadingD {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.ring-1 {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  padding: 7px;
  border: 8px dashed #4b9cdb;
  border-radius: 100%;
}

.load-6 .letter {
  animation-name: loadingF;
  animation-duration: 1.6s;
  animation-iteration-count: infinite;
  animation-direction: linear;
}

.letter-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4b9cdb;
  font-size: 20px;
}

.l-1 {
  animation-delay: 0.48s;
}

.l-2 {
  animation-delay: 0.6s;
}

.l-3 {
  animation-delay: 0.72s;
}

.l-4 {
  animation-delay: 0.1s;
}

.l-5 {
  animation-delay: 0.96s;
}

.l-6 {
  animation-delay: 1.08s;
}

.l-7 {
  animation-delay: 1.2s;
}

.l-8 {
  animation-delay: 1.32s;
}

.l-9 {
  animation-delay: 1.44s;
}

.l-10 {
  animation-delay: 1.56s;
}

@keyframes loadingF {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
/* // ======================================End loading..==========================================// */
</style>
